"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "useEffect", {
  enumerable: true,
  get: function () {
    return _react.useEffect;
  }
});
Object.defineProperty(exports, "useLayoutEffect", {
  enumerable: true,
  get: function () {
    return _react.useLayoutEffect;
  }
});
var _react = require("react");
// Silences layout effect warnings during server side rendering. Required until
// the next React version is released and widely adopted.
// @see https://github.com/facebook/react/pull/26395
var _default = exports.default = typeof document === 'object' ? _react.useLayoutEffect : _react.useEffect;